module.exports = __webpack_public_path__ + "static/img/initiative1.6ffce3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/initiative1.png
// module id = GeH4
// module chunks = 1